import { render } from "./editotherincome.vue?vue&type=template&id=5430c5b3&scoped=true"
import script from "./editotherincome.vue?vue&type=script&lang=js"
export * from "./editotherincome.vue?vue&type=script&lang=js"

import "./editotherincome.vue?vue&type=style&index=0&id=5430c5b3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5430c5b3"]])

export default __exports__